import { GetProp, UploadProps } from "antd";
import { z } from "zod";

export const zUploadResult = z.object({
  status: z.union([z.literal("success"), z.literal("error")]),
  description: z.string(),
});

export type ZUploadResult = z.infer<typeof zUploadResult>;

export const zImportStatus = z.object({
  status: z.enum(["PROCESS"]),
  objectName: z.string(),
  fileName: z.string(),
});

export type ZImportStatus = z.infer<typeof zImportStatus>;

export type FileType = Parameters<GetProp<UploadProps, "beforeUpload">>[0];
